export default __webpack_public_path__ + "static/media/pic5.4b85c20d.jpg";